import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';

interface NewsCardProps {
  item: NewsItem;
  layout?: 'stacked' | 'row';
}

export default function NewsCard({ item, layout = 'stacked' }: NewsCardProps) {
  if (layout === 'row') {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200"
      >
        <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title}配图`}
            title={`${item.title} 粉色水蜜桃资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <span className="text-xs font-medium text-primary-600">{item.category}</span>
          <h3 className="mt-1 line-clamp-2 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
            {item.title}
          </h3>
          <p className="mt-1 text-xs text-foreground-500">{item.date}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}配图`}
          title={`${item.title} 粉色水蜜桃资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-primary-50 px-2 py-0.5 font-medium text-primary-600">
            {item.category}
          </span>
          <span>{item.date}</span>
        </div>
        <h3 className="mt-2.5 line-clamp-2 text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </span>
      </div>
    </Link>
  );
}